import { render } from "./SidebarCatalogue.vue?vue&type=template&id=c4117e3c&scoped=true"
import script from "./SidebarCatalogue.vue?vue&type=script&lang=js"
export * from "./SidebarCatalogue.vue?vue&type=script&lang=js"

import "./SidebarCatalogue.vue?vue&type=style&index=0&id=c4117e3c&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4117e3c"]])

export default __exports__